export default __webpack_public_path__ + "static/media/upload_file.a713efc7.svg";